import React, { Component } from 'react';
import { Container } from 'reactstrap';
import CreateQuote from './create-quote';
import QuoteSummary from './quote-summary';
import CreatePolicyholder from './create-policyholder';
import PaymentDetails from './payment-details';
import CheckoutSummary from './checkout-summary';
import PolicyIssued from './policy-issued';
import AddBeneficiaries from './add-beneficiaries';

class ProgressBar extends Component {
  constructor (props) {
    super(props);
    this.state = {
      step: props.step
    };
  }
  componentWillReceiveProps (nextProps) {
    this.setState({ step: nextProps.step });
  }
  render () {
    return <div className='d-flex justify-content-around'>
      {
        this.props.steps.map((s, i) =>
          <div className={'progress-step-container' + (this.props.step > i ? ' done' : '') + (this.props.step === i ? ' active' : '')} key={i}>
            <div className='progress-step'>
              <div className='progress-dot' />
              <div className='progress-line' />
            </div>
            <div className='progress-name'>{s}</div>
          </div>
        )
      }
    </div>;
  }
}

class Application extends Component {
  constructor (props) {
    super(props);
    this.state = {
      step: 0,
      data: {
        // Quote
        quote: {
        },

        // Policy number
        policyNumber: undefined,

        // Policholder
        policyholder: {
          type: 'policyholder',
          coverAmount: undefined,
          dateOfBirth: undefined,
          gender: undefined,
          firstName: undefined,
          lastName: undefined,
          email: undefined,
          cellphone: undefined,
          id: {
            type: 'id',
            country: 'ZA',
            number: undefined
          }
        },

        // Other family
        spouse: undefined, // { dateOfBirth, firstName, lastName, gender }
        spouseCoverAmount: undefined,
        children: [], // { dateOfBirth, firstName, lastName }
        childrenCoverAmount: undefined,
        extendedFamily: [], // { dateOfBirth, firstName, lastName, gender, relationship }
        extendedFamilyCoverAmount: undefined,

        // Beneficiaries
        beneficiaries: [
          {
            firstName: undefined,
            lastName: undefined,
            email: undefined,
            cellphone: undefined,
            id: {
              type: 'id',
              country: 'ZA',
              number: undefined
            },
            bankDetails: {
              type: 'eft',
              bankName: undefined,
              branchCode: undefined,
              accountType: 'cheque_account',
              accountNumber: undefined
            },
            percentage: 100
          }
        ],

        // Payment method
        paymentMethod: {
          type: 'debit_order',
          billingDay: 1,
          bankDetails: {
            accountHolder: undefined,
            bankName: undefined,
            branchCode: undefined,
            accountNumber: undefined
          }
        },

        // Agent details
        agent: {
          agentCode: undefined
        }
      }
    };
  }
  setData (data) {
    this.setState({ data });
  }
  previousStep () {
    this.setState({ step: this.state.step - 1 });
  }
  nextStep () {
    this.setState({ step: this.state.step + 1 });
  }
  renderStep () {
    switch (this.state.step) {
      case 0:
        return <CreateQuote setData={this.setData.bind(this)} data={this.state.data} previousStep={this.previousStep.bind(this)} nextStep={this.nextStep.bind(this)} />;
      case 1:
        return <QuoteSummary setData={this.setData.bind(this)} data={this.state.data} previousStep={this.previousStep.bind(this)} nextStep={this.nextStep.bind(this)} />;
      case 2:
        return <CreatePolicyholder setData={this.setData.bind(this)} data={this.state.data} previousStep={this.previousStep.bind(this)} nextStep={this.nextStep.bind(this)} />;
      case 3:
        return <AddBeneficiaries setData={this.setData.bind(this)} data={this.state.data} previousStep={this.previousStep.bind(this)} nextStep={this.nextStep.bind(this)} />;
      case 4:
        return <PaymentDetails setData={this.setData.bind(this)} data={this.state.data} previousStep={this.previousStep.bind(this)} nextStep={this.nextStep.bind(this)} />;
      case 5:
        return <CheckoutSummary setData={this.setData.bind(this)} data={this.state.data} previousStep={this.previousStep.bind(this)} nextStep={this.nextStep.bind(this)} />;
      case 6:
        return <PolicyIssued setData={this.setData.bind(this)} data={this.state.data} previousStep={this.previousStep.bind(this)} nextStep={this.nextStep.bind(this)} />;
      default:
        return <div>No step found.</div>;
    }
  }
  render () {
    return <div>
      <Container className='pt-5'>
        <ProgressBar step={this.state.step} steps={['Get quote', 'Review quote', 'Complete details', 'Add beneficiaries', 'Payment details', 'Confirm policy']} />
        <br />
        <br />
        <div className='page-container'>
          {this.renderStep()}
        </div>
      </Container>
      <footer>
        <hr />
        <img id='guardrisk-logo' src='/funeral/guardrisk-mmi-logo.png' />
        <p>
          <b>© 2018 Oats Risk Services Limited. All rights reserved.</b>
          <br />
          Oats risk services (Pty) Limited is an authorised financial services provider, FSP no. 49169 | Oats Funeral Cover is underwritten by Guardrisk Life Limited (Reg no. 1999/013922/06), a registered Financial Services Provider, FSP no. 76.
        </p>
      </footer>
    </div>;
  }
}

export default Application;



// WEBPACK FOOTER //
// ./src/components/application/index.js